var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",style:(_vm.style)},[_c('table',[_c('tbody',[_c('tr',[(!_vm.hasImage)?_c('td',[_vm._v(" "+_vm._s(_vm.initials)+" ")]):_vm._e()])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }